import { httpClient } from '@/utils/http-client';
class IntegrationService {
    httpClient;
    constructor() {
        this.httpClient = httpClient;
    }
    async get() {
        const response = await this.httpClient.get('/integration');
        return response.data;
    }
    async link(identifier, integrationId) {
        const payload = {
            integrationId: integrationId,
            identifier: identifier
        };
        const response = await this.httpClient.post(`integration/link`, payload);
        return response.data;
    }
    async unlink(integrationUserId) {
        const payload = {
            integrationUserId: integrationUserId
        };
        const response = await this.httpClient.post(`integration/unlink`, payload);
        return response.data;
    }
    async getUserIntegration(id) {
        const response = await this.httpClient.get(`integration/${id}`);
        return response.data;
    }
    async getIntegrationMedia(integrationId) {
        const response = await this.httpClient.get(`integration/media/${integrationId}`);
        return response.data;
    }
    async downloadMedia(integrationUserId, media) {
        let type;
        if (media.media_url == '') {
            type = 'ftp';
        }
        else {
            type = 'aws';
        }
        const payload = {
            integrationUserId: integrationUserId,
            filename: media.file_name,
            mediaUrl: media.media_url,
            type: type
        };
        const response = await this.httpClient.post(`video/integration/download`, payload);
        return response.data;
    }
}
export default IntegrationService;
